export const SET_IS_PENDING = 'rpb2b-react/accountview/SET_IS_PENDING';
export type SET_IS_PENDING = typeof SET_IS_PENDING;

export const SET_ERROR = 'rpb2b-react/accountview/SET_ERROR';
export type SET_ERROR = typeof SET_ERROR;

export const SET_MENU_OPTION = 'rpb2b-react/accountview/SET_MENU_OPTION';
export type SET_MENU_OPTION = typeof SET_MENU_OPTION;

export const SET_CURRENT_PASSWORD =
  'rpb2b-react/accountview/SET_CURRENT_PASSWORD';
export type SET_CURRENT_PASSWORD = typeof SET_CURRENT_PASSWORD;

export const SET_NEW_PASSWORD = 'rpb2b-react/accountview/SET_NEW_PASSWORD';
export type SET_NEW_PASSWORD = typeof SET_NEW_PASSWORD;

export const SET_NEW_PASSWORD_REPEAT =
  'rpb2b-react/accountview/SET_NEW_PASSWORD_REPEAT';
export type SET_NEW_PASSWORD_REPEAT = typeof SET_NEW_PASSWORD_REPEAT;

export const SET_NEW_PASSWORD_VALIDATION =
  'rpb2b-react/accountview/SET_NEW_PASSWORD_VALIDATION';
export type SET_NEW_PASSWORD_VALIDATION = typeof SET_NEW_PASSWORD_VALIDATION;

export const SET_SHIP_ADDRESS = 'rpb2b-react/accountview/SET_SHIP_ADDRESS';
export type SET_SHIP_ADDRESS = typeof SET_SHIP_ADDRESS;

export const SET_SHIP_ADDRESS_SUCCED =
  'rpb2b-react/accountview/SET_SHIP_ADDRESS_SUCCED';
export type SET_SHIP_ADDRESS_SUCCED = typeof SET_SHIP_ADDRESS_SUCCED;

export const SET_SHIP_ADDRESS_FAILED =
  'rpb2b-react/accountview/SET_SHIP_ADDRESS_FAILED';
export type SET_SHIP_ADDRESS_FAILED = typeof SET_SHIP_ADDRESS_FAILED;

export const SET_SHIP_ADDRESS_VALIDATION =
  'rpb2b-react/accountview/SET_SHIP_ADDRESS_VALIDATION';
export type SET_SHIP_ADDRESS_VALIDATION = typeof SET_SHIP_ADDRESS_VALIDATION;

export const SET_DELIVERY_STATUS =
  'rpb2b-react/accountview/SET_DELIVERY_STATUS';
export type SET_DELIVERY_STATUS = typeof SET_DELIVERY_STATUS;
export const SET_CC_STATUS = 'rpb2b-react/accountview/SET_CC_STATUS';
export type SET_CC_STATUS = typeof SET_CC_STATUS;

export default {
  SET_IS_PENDING,
  SET_ERROR,
  SET_MENU_OPTION,
  SET_CURRENT_PASSWORD,
  SET_NEW_PASSWORD,
  SET_NEW_PASSWORD_REPEAT,
  SET_NEW_PASSWORD_VALIDATION,
  SET_SHIP_ADDRESS,
  SET_SHIP_ADDRESS_SUCCED,
  SET_SHIP_ADDRESS_FAILED,
  SET_SHIP_ADDRESS_VALIDATION,
  SET_DELIVERY_STATUS,
  SET_CC_STATUS
};
